// @flow

import { REHYDRATE } from "redux-persist/constants"

function processAuth ( oldAuth ) {
  if ( oldAuth && oldAuth.ok ) {
    return oldAuth
  } else {
    return null
  }
}


export default ( state: any = {}, action: any ) => {
  switch ( action.type ) {
  case REHYDRATE:
    var incoming = action.payload
    if ( incoming ) {
      return {
        ...state,
        auth: processAuth( incoming.auth ),
      }
    }
    return state
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/rehydrate.jsx